import React, { forwardRef } from 'react'

import { twMerge } from 'tailwind-merge'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

interface IconButton extends Omit<React.HTMLProps<HTMLButtonElement>, 'type'> {
  type?: 'button' | 'submit' | 'reset'
  tooltipContent?: React.ReactNode
}

export const ICON_BUTTON_STYLES: string =
  'rounded-md p-1 active:brightness-95 transition duration-100 focus:ring-0 focus:rounded-md focus:outline-none'

const IconButton = forwardRef<HTMLButtonElement, IconButton>(
  ({ children, className, disabled, tooltipContent, ...props }, ref) => {
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild={true}>
          <button
            ref={ref}
            disabled={disabled}
            {...props}
            className={twMerge(
              ICON_BUTTON_STYLES,
              disabled
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:bg-primary-100 dark:hover:bg-primary-700',
              className ?? '',
            )}
          >
            {children}
          </button>
        </TooltipTrigger>
        {tooltipContent && <TooltipContent>{tooltipContent}</TooltipContent>}
      </Tooltip>
    )
  },
)

IconButton.displayName = 'IconButton'

export default IconButton
